import { useEffect } from 'react'
import {
  Meta,
  Links,
  ScrollRestoration,
  Scripts,
  useLocation,
  useRouteLoaderData,
} from '@remix-run/react'
import { trackGlobalEvents } from '~/utils/tracking'
import useCookie from '~/hooks/useCookie'
import { CIOAppContext } from '~/types/common_cio'

export type DocumentProps = { children: React.ReactNode; title?: string; canonicalTag?: string }

export const Document = ({ children, title, canonicalTag }: DocumentProps) => {
  const { cookie_consent } = useCookie()
  const location = useLocation()
  const {
    data: { SENTRY },
  } = useRouteLoaderData<CIOAppContext>('root') as CIOAppContext

  useEffect(() => {
    trackGlobalEvents()
  }, [location])

  const canonicalHref = canonicalTag
    ? canonicalTag.endsWith('/')
      ? canonicalTag.slice(0, -1)
      : canonicalTag
    : ''

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="google-site-verification"
          content="J6FWXx2fU3b_ARQyWmIk_j6WoW7dgwkFPE9Ikvylt0E"
        />
        <meta name="theme-color" content="#ffffff" />
        {title ? <title>{title}</title> : <></>}
        {canonicalHref ? <link rel="canonical" href={canonicalHref} /> : <></>}
        <Meta />
        <Links />
        <script
          defer
          suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html: `window.SENTRY = ${JSON.stringify(SENTRY)}`,
          }}
        />
        <script
          defer
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent', 'default', ${JSON.stringify({
              ad_storage: cookie_consent?.essentialCookies ? 'granted' : 'denied',
              ad_user_data: cookie_consent?.essentialCookies ? 'granted' : 'denied',
              ad_personalization: cookie_consent?.marketingAndTrackingCookies
                ? 'granted'
                : 'denied',
              analytics_storage: cookie_consent?.analyticalCookies ? 'granted' : 'denied',
            })});
          `,
          }}
        />
      </head>
      <body>
        {children}

        {process.env.NODE_ENV !== 'development' && cookie_consent.analyticalCookies && (
          <>
            <script
              async
              dangerouslySetInnerHTML={{
                __html: `
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event:'gtm.js' });
                `,
              }}
            />
          </>
        )}

        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}
